var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "eye",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#134563"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 47.4c-16.2 0-23.5-14.3-23.8-14.9-.2-.4-.2-.8 0-1.2.3-.6 7.6-14.9 23.8-14.9s23.5 14.3 23.8 14.9c.2.4.2.8 0 1.2-.3.7-7.6 14.9-23.8 14.9zM10.9 32c1.5 2.6 8.4 12.8 21.1 12.8 12.7 0 19.6-10.2 21.1-12.8-1.5-2.6-8.4-12.8-21.1-12.8-12.7 0-19.6 10.2-21.1 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44.6c-7 0-12.6-5.7-12.6-12.6S25.1 19.4 32 19.4 44.6 25.1 44.6 32 39 44.6 32 44.6zM32 22c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39c-3.8 0-7-3.1-7-7 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3 3.8 0 7 3.1 7 7S35.8 39 32 39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9ff9ca819f78632f47c4e87ae99acca6.svg";
export { ForwardRef as ReactComponent };